import React, { useEffect, useState } from "react";
import Layout from "../../../../layout/Layout";
import { Backdrop, Box, CircularProgress, Grid } from "@mui/material";
import ProfileLeftPanel from "../../../../components/Profile/MyProfile/ProfileLeftPanel";
import ProfileBox from "../../../../components/Profile/MyProfile/ProfileBox";
import axiosInstance from "../../../../utils/config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const OthersProfile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const userId = location.pathname.split("/").pop();

  const { userData } = useSelector((state) => state.user);

  const [otherUser, setOtherUser] = useState(null);

  const [loading, setloading] = useState(false);

  const getOtherUser = async () => {
    try {
      const response = await axiosInstance.get(
        `user/getSpecificUser?userId=${userId}`
      );

      if (response.status === 200) {
        setOtherUser(response.data?.user);
      }
    } catch (error) {
      console.error("Error fetching other user data:", error);
    }
  };

  useEffect(() => {
    getOtherUser();
  }, [userId]);

  const createConversation = async () => {
    try {
      setloading(true);
      const response = await axiosInstance.post(
        "/conversation/createConversation",
        {
          user1Id: userData?.id,
          user2Id: parseInt(userId),
        }
      );

      if (response.status === 200) {
        console.log("Conversation created successfully:", response.data);
        navigate("/messages", {
          state: { conversationId: response.data?.id },
        });
        setloading(false);
      }
    } catch (error) {
      console.error("Error creating conversation:", error);
      setloading(false);
    }
  };

  return (
    <Layout
      heading={"Profile"}
      btnText={"Send Message"}
      onCreate={createConversation}
    >
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ height: "100%" }}>
        <Grid container spacing={2}>
          <Grid item size={{ xs: 12, sm: 3 }}>
            <ProfileLeftPanel user={otherUser} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 9 }}>
            <ProfileBox user={otherUser} />
          </Grid>
        </Grid>
      </Box>
    </Layout>
  );
};

export default OthersProfile;
